import { CheckInput } from '@smooved/ui';

export const perMonthDefault = false;
export const perMonthOption: CheckInput<boolean> = {
    id: 'PerMonth',
    name: 'perMonth',
    value: true,
    labelResource: 'MOVE.ENERGY.SUGGESTIONS.SHOW_PRICES_PER_MONTH',
};
